import {
  useQuery,
  UseQueryOptions,
  UseQueryResult,
} from "@tanstack/react-query";
import axiosAuth from "../axiosAuth";
import { BUDGET } from "./apiRoutes";

interface UseGetBudgetDataProps {
  communityId: string;
  queryParams?: Omit<UseQueryOptions, "queryKey">;
}

const getBudgetDataByCommunity = async (communityId: string) =>
  await axiosAuth.get(BUDGET(communityId));

const useGetBudgetByCommunityData = ({
  queryParams,
  communityId,
}: UseGetBudgetDataProps): UseQueryResult<any> => {
  return useQuery({
    queryKey: ["get-budget-data", communityId],

    queryFn: () => getBudgetDataByCommunity(communityId),

    select: (data: any) => data.data,

    refetchOnWindowFocus: false,

    ...queryParams,

    enabled: !!communityId && (queryParams?.enabled ?? true),
  });
};

export default useGetBudgetByCommunityData;
